import { createSelector } from 'reselect'

export const getTechnicalInspectionForm = createSelector(
  state => state && state.scheduleTechnicalInspection && state.scheduleTechnicalInspection.formData ? state.scheduleTechnicalInspection.formData : null,
  formData => formData
)
